/**
 * Get the total number of configurations for a certain product ID
 * Used to show totals on step 1 table
 * @param configs
 * @param productId
 */
export function getProductConfigCount(configs: any, productId: string) {
  let count = 0;
  configs.forEach((item: any) => {
    if (item.productId === productId) count++;
  });
  return count;
}

/**
 * Get products sorted alphabetically by name.
 * @param products
 */
export function getSortedProducts(products: any) {
  products = products.slice().sort(function (a: any, b: any) {
    return a.name.localeCompare(b.name);
  });
  return products;
}

/**
 * Get index of product config.
 * @param configs
 * @param productId
 */
export function getIndexOfProductConfig(configs: any, productId: string) {
  const configIndex = configs.findIndex(
    (item: any) => item.productId === productId
  );
  return configIndex;
}
